var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs-header"},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:tab.title,staticClass:"tab-heading",class:{
        'selected': (index === _vm.selectedIndex)
      },on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }